import {useContext, useState} from "react";
import {isCurrentPageDenyQuery, useStartApi} from "../services/api/ApiContext";
import {getUserFactor} from "../services/api/profileApi";
import {useOktaAuth} from "@okta/okta-react";
import {useLocation} from "react-use";

const {createContext} = require("react");

const factorsContext = createContext(null);

const getUserFactorProcess = ({data}) => ({
	factors: data?.data?.factors,
})

export const FactorsProvider = ({children}) => {
	const {authState} = useOktaAuth();
	const location = useLocation();
	const [lastUpdate, forceUpdate] = useState(-1);
	const denyQuery = isCurrentPageDenyQuery(location)

	const { data } = useStartApi(['getFactor', lastUpdate, authState?.accessToken], getUserFactor, getUserFactorProcess, {
		enabled: !denyQuery && !!authState?.isAuthenticated && !!authState?.accessToken,
	});

	const refresh = () => forceUpdate(Date.now);

	return (
		<factorsContext.Provider value={{
			data,
			refresh,
		}}>
			{children}
		</factorsContext.Provider>
	);
}

export const useFactors = () => useContext(factorsContext);
